export default __webpack_public_path__ + "static/media/vista.4a62d81d.png";